/* eslint-disable camelcase */
import React from 'react'
import {
  Details,
  Flex
} from '@nautilusjs/component-core'
import isEmpty from 'lodash/isEmpty'
import { Box } from '@maui/elements'

function formatShortDate(dataString) {
  const options = { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }
  return new Date(dataString).toLocaleDateString(undefined, options)
}

const mandiantSource = () => (
  <Box
    background='url(/icons/MandiantLogoWhite.svg) no-repeat'
    backgroundSize='20px'
    paddingLeft='2rem'
  > Mandiant</Box>
)

export const SourcesWidget = ({
  sources,
  css
}) => (
  <Box
    width='100%'
    borderBottomColor='colorBorderMain'
    borderBottomWidth='1px'
    borderBottomStyle='solid'
    paddingBottom='1rem'
    flexDirection='row'
    marginBottom='1rem'
    {...css}
  >
    { sources.map((source, i) => {
      const { source_name, category, first_seen, last_seen } = source
      const formattedSource = source_name === 'mandiant_threat_intel' ? mandiantSource() : source_name
      const detailsStyles = {
        dt: {
          flex: '0 0 9rem',
          marginTop: '0.2rem',
          marginBottom: '0.2rem',
        },
        dd: {
          flex: '1',
          marginTop: '0.2rem',
          marginBottom: '0.2rem',
        }
      }
      return (
        <Box
          key={i}
          width='60%'
          minWidth='40rem'
          marginBottom='1rem'
        >
          <Flex>
            <Details.Term style={detailsStyles.dt}>Source</Details.Term>
            <Details.Definition style={detailsStyles.dd}>{formattedSource}</Details.Definition>
            { !isEmpty(category) && (
              <>
                <Details.Term style={detailsStyles.dt}>Category</Details.Term>
                <Details.Definition style={detailsStyles.dd}>{category.join(' ')}</Details.Definition>
              </>
            )}
          </Flex>
          <Flex>
            { !isEmpty(first_seen) && (
              <>
                <Details.Term style={detailsStyles.dt}>First Seen</Details.Term>
                <Details.Definition style={detailsStyles.dd}>{formatShortDate(first_seen)}</Details.Definition>
              </>
            )}
            { !isEmpty(last_seen) && (
              <>
                <Details.Term style={detailsStyles.dt}>Last Seen</Details.Term>
                <Details.Definition style={detailsStyles.dd}>{formatShortDate(last_seen)}</Details.Definition>
              </>
            )}
          </Flex>
        </Box>
      )
    }
    )}
  </Box>
)

export default SourcesWidget
